import Blowfish from 'egoroof-blowfish';
import {getRootStore} from '../../app.bootstrap';

export interface ITsSessionData {
    setValue(key: string, value: any): Promise<void>;
    getValue(key: string): Promise<any>;
}

export class TsSessionData implements ITsSessionData {
    private bf: Blowfish;
    private password: string;

    constructor() {
        const authValue = getRootStore().authService.getAuthToken() || '';

        this.password = authValue || 'noAuthToken';
        this.bf = new Blowfish(this.password);
        getRootStore().authService.on('newToken', () => {
            getRootStore().browserUtilsService.removeFromSessionStorage('tsSessionData');
        });
    }
    setValue(key: string, value: any): Promise<void> {
        let storage: Record<string, any> = {};

        if (getRootStore().browserUtilsService.getFromSessionStorage('tsSessionData')) {
            let encodedData = getRootStore().browserUtilsService.getFromSessionStorage('tsSessionData');

            if (!(encodedData instanceof Uint8Array)) {
                encodedData = this._objectToUint8Array(encodedData);
            }

            try {
                // @ts-ignore
                storage = JSON.parse(this.bf.decode(encodedData));
            } catch (e) {
                // Decryption failed (e.g. auth token changed) — start fresh
                storage = {};
            }
        }

        storage[key] = value;

        // Encode and save the data in the session storage
        getRootStore().browserUtilsService.saveToSessionStorage(
            'tsSessionData',
            this.bf.encode(JSON.stringify(storage))
        );

        return Promise.resolve();
    }

    getValue(key: string): Promise<any> {
        if (getRootStore().browserUtilsService.getFromSessionStorage('tsSessionData')) {
            let encodedData = getRootStore().browserUtilsService.getFromSessionStorage('tsSessionData');

            if (!(encodedData instanceof Uint8Array)) {
                encodedData = this._objectToUint8Array(encodedData);
            }

            try {
                // @ts-ignore
                const decoded = JSON.parse(this.bf.decode(encodedData));

                return Promise.resolve(decoded[key]);
            } catch (e) {
                return Promise.resolve(undefined);
            }
        }

        return Promise.resolve(undefined);
    }

    private _objectToUint8Array(obj: any): Uint8Array {
        const array = new Uint8Array(40);

        for (let index = 0; index <= array.length; index++) {
            array[index] = obj[index];
        }

        return array;
    }
}
